import { render, staticRenderFns } from "./RecommendationButtons.vue?vue&type=template&id=59fd0260&"
import script from "./RecommendationButtons.vue?vue&type=script&lang=js&"
export * from "./RecommendationButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports